import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue'

const testRoutes: RouteConfig = {
    path: '/test',
    component: Layout,
    meta: {
        title: 'test',
        icon: 'international',
        redirect: '/test/test',
        // alwaysShow: true 
    },
    children: [
        {
            path: 'test',
            component: () => import('@/views/test/test.vue'),
            meta: {
                // title: 'adminList',
                title: 'test',
                icon: 'international',
                activeMenu: '/test/test',
            }
        }
    ]

}

export default testRoutes